import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { FileResponse } from '../models/fileResponse';
import { Progress } from '../models/progress.model';
import { BaseService } from './base.service';

type UploadResultType = Progress | FileResponse | null | any;

@Injectable()
export class OrderStoreUseService extends BaseService {
  public headers: HttpHeaders;

  constructor(
    private readonly http: HttpClient,
    private readonly logger: NGXLogger
  ) {
    super();
    this.envService = this.env.services.orderRequestFixAsset;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public getUrlImport() {
    return this.getFullUrl(this.envService.import);
  }

  public uploadOrderStoreUseFiles(
    files: File[],
    url: string,
    wmsCode: string,
    storeCode: string,
    state: string
  ): Observable<UploadResultType>[] {
    return files.map(file => this.uploadOrderStoreUseFile(file, url, wmsCode, storeCode, state));
  }

  public uploadOrderStoreUseFile(
    file: File,
    url: string,
    wmsCode: string,
    storeCode: string,
    state: string
  ): Observable<UploadResultType> {
    const formData = new FormData();

    formData.append('file', file, file.name);

    formData.append('wmsCode', wmsCode ? wmsCode : '');
    formData.append('storeCode', storeCode ? storeCode : '');
    formData.append('state', state ? state : '');

    this.headers.append('Content-Type', 'multipart/form-data');

    return this.http
      .post<any>(url, formData, {
        reportProgress: true,
        observe: 'events',
        headers: this.loaderHeaders()
      })
      .pipe(
        map(event => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = Math.round((100 * event.loaded) / event.total);
              return { status: 'progress', message: progress };
            case HttpEventType.Response:
              return { ...event.body, status: 'done' };
            default:
              const msg = `Unhandled event: ${HttpEventType[event.type]}`;
              this.logger.info(msg);
              return null;
          }
        }),
        catchError(err => {
          return of(err);
        })
      );
  }
}
